import { NestInterceptor, Type, UnprocessableEntityException } from '@nestjs/common';
import { FilesInterceptor as NestFilesInterceptor } from '@nestjs/platform-express';
import config from 'config';

export const FilesInterceptor = (type: string, maxCount = 10): Type<NestInterceptor> => {
  const options = config.get<any>('multer');
  return NestFilesInterceptor('files', maxCount, {
    dest: config.get('paths.temporary'),
    fileFilter: (request, file, callback) => {
      if (options[type].mimeTypes.includes(file.mimetype)) return callback(null, true);
      return callback(new UnprocessableEntityException([`Unsupported file type: ${file.mimetype}`]), false);
    },
    limits: options[type].limits,
  });
};
